import React from "react";
import { audienceItems } from "./landingContent";

export default function LandingAudience() {
  return (
    <section
      className="hr-landing-section hr-landing-section--dark"
      aria-labelledby="hr-landing-audience-title"
    >
      <div className="home-page__container">
        <header className="hr-landing-section__head hr-landing-section__head--center">
          <h2 id="hr-landing-audience-title" className="hr-landing-section__title hr-landing-section__title--on-dark">
            למי זה מתאים
          </h2>
        </header>
        <ul className="hr-landing-audience">
          {audienceItems.map((line, i) => (
            <li key={i} className="hr-landing-audience__item">
              {line}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
